/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */

export type GetFlagResponse = {
	status: boolean;
	lastSeenDate: string;
};

export async function getFlag(
	_stargateUrl: string,
	_cloudId: string,
	_flagKey: string,
	_userKey: string,
): Promise<GetFlagResponse> {
	return { status: false, lastSeenDate: '' };
}

export async function setFlag(
	_stargateUrl: string,
	_cloudId: string,
	_flagKey: string,
	_userKey: string,
): Promise<void> {
	return Promise.resolve();
}
